import { render } from "./skip-backward.vue?vue&type=template&id=1a6797f7"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/skip-backward.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a6797f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a6797f7', __exports__)) {
    api.reload('1a6797f7', __exports__)
  }
  
  module.hot.accept("./skip-backward.vue?vue&type=template&id=1a6797f7", () => {
    api.rerender('1a6797f7', render)
  })

}


export default __exports__